<app-step-challenge-form
  [isSaving]="isSaving()"
  [goBackNavigate]="goBackNavigate"
  (save)="onSave($event)"
  (back)="goBack()"
></app-step-challenge-form>

<app-save-changes-confirmation
  [navigate]="goBackNavigate"
  data-test-id="step-challenges-save-changes-confirmation"
></app-save-changes-confirmation>
